import { render, staticRenderFns } from "./QueueSection.vue?vue&type=template&id=158f616b"
import script from "./QueueSection.vue?vue&type=script&lang=js"
export * from "./QueueSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports